// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AppInfo  {
    _originalTypeClassName = "Loom.BO.AppInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AppInfo.translate = translateService;
}
this.Name = null;
this.SemanticVersion = null;
this.Version = null;
this.ImplementationStrategyVersion = null;
this.ReleaseNotes = null;
this._key = this.Version = ""; 
}

static translate: TranslateService;
_key: any;
Name:any;
SemanticVersion:any;
private _Version:any;
get Version(): any {
    return this._Version;
  }
set Version(value: any) {
    this._Version = value;
    this._key = value;
  }
ImplementationStrategyVersion:any;
ReleaseNotes:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Version == null || $this.Version == "";
            }


}